module.exports = __webpack_public_path__ + "static/media/occupancyActive.0b825fde.svg";